export default __webpack_public_path__ + "static/media/Logo.4fd9e37e.png";